import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";

const API_URL = environment.apiUrl + 'sync/';

@Injectable({
  providedIn: 'root'
})
export class SyncService {

  constructor(private http: HttpClient) {}

  syncEvent(id: number) {
    return this.http.post(API_URL + id, {}, { responseType: 'json' });
  }
}
